import styled from 'styled-components';
import { PipelineLeadListItemStatusesColumn } from '../PipelineLeadListItem.styles';

export const PipelineLeadListItemStatusesLoadingPlaceholderColumn = styled(
  PipelineLeadListItemStatusesColumn,
)`
  align-items: center;
  gap: 2em;
`;
